import { useEffect, useState } from "react";
import { onAuthStateChanged } from "firebase/auth";
import type { User } from "firebase/auth";
import { auth } from "../firebase";
import { isDemoEmail } from "./demoUser";

export interface CurrentUserState {
  user: User | null;
  isDemo: boolean;
  loading: boolean;
}

export function useCurrentUser(): CurrentUserState {
  const [user, setUser] = useState<User | null>(auth.currentUser);
  const [loading, setLoading] = useState<boolean>(auth.currentUser === null);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (u) => {
      setUser(u);
      setLoading(false);
    });
    return () => unsub();
  }, []);

  return { user, isDemo: isDemoEmail(user?.email), loading };
}

export function firstName(user: User | null): string {
  if (!user) return "there";
  if (user.displayName) return user.displayName.split(/\s+/)[0] || "there";
  if (user.email) return user.email.split("@")[0] || "there";
  return "there";
}
